import { useThemePreference, type ThemePreference } from "../lib/theme";

/**
 * Appearance section for the Control Center: a 3-way segmented control letting
 * the user pick how the app is themed. "System" (follow the OS) is the default
 * and is shown first. The choice persists and applies immediately via the
 * shared theme store.
 */

const OPTIONS: { value: ThemePreference; label: string; hint: string }[] = [
  { value: "system", label: "System", hint: "Match your device's appearance" },
  { value: "light", label: "Light", hint: "Always use the light theme" },
  { value: "dark", label: "Dark", hint: "Always use the dark theme" },
];

export function Appearance() {
  const [pref, setPref] = useThemePreference();
  const activeHint =
    OPTIONS.find((o) => o.value === pref)?.hint ?? "Match your device's appearance";

  return (
    <div className="card">
      <h2>Appearance</h2>
      <div
        className="theme-segmented"
        role="radiogroup"
        aria-label="Theme preference"
      >
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={pref === opt.value}
            className={`theme-seg${pref === opt.value ? " on" : ""}`}
            onClick={() => setPref(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <p className="muted small theme-seg-hint">{activeHint}</p>
    </div>
  );
}
